var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{staticClass:"mt-0",attrs:{"cycle":"","hide-delimiters":"","height":"400px"}},_vm._l((_vm.photos),function(photo,i){return _c('v-carousel-item',{key:i,attrs:{"contain":"","src":photo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }